module.exports = __webpack_public_path__ + "2bc2138062a33183744cf03be7fbe70b.png";